import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as GrIcons from "react-icons/gr";
import LoadingSpinner from "../utilities/LoadingSpinner";
import moment from "moment";

import AdminRegistration from "../../context/adminRegistration/adminRegistrationContext";
import AuthContext from "../../context/auth/authContext";

import ProgressLevelBar from "./ProgressLevelBar";

import RegistrationContext from "../../context/registration/registrationContext";

import ScheduleOrientation from "../../components/registrationAdmin/ScheduleOrientation";

const PostRegistrationModal = () => {
  const navigate = useNavigate();
  const [scheduleOrientation, setScheduleOrientation] = useState(false);
  const adminRegistrationContext = useContext(AdminRegistration);
  const { setFormModal, formData, updateProcessingLevel, clearFormData } =
    adminRegistrationContext;
  const registrationContext = useContext(RegistrationContext);
  const { submitData } = registrationContext;

  const { firstName, progressLevel } = formData;

  const introBlock = (
    <>
      <div className="intro-text">
        <p>{firstName}'s Registration Form is Complete!</p>
        <p>Would you like to schedule an orientation?</p>
      </div>
      <div className="selection-btns">
        <div
          onClick={() => setScheduleOrientation(true)}
          className="btn btn-llac-dark-grey"
        >
          Schedule Orientation Now
        </div>
        <div
          onClick={async () => {
            await submitData({ ...formData, progressLevel: 1 });
            navigate("/registration-forms");
            setFormModal("postRegistrationModal", false);
            clearFormData();
          }}
          className="btn btn-llac-dark-grey"
        >
          Schedule Orientation Later
        </div>
      </div>
    </>
  );

  return (
    <div id="post-registration-modal" className="modal">
      <div className="post-registration-content modal-content">
        <div className="top-bar">
          {/* <GrIcons.GrFormClose
            className="close-icon"
            onClick={() => setFormModal("postRegistrationModal", false)}
          /> */}
          <ProgressLevelBar level={progressLevel} />
        </div>
        <div className="modal-body">
          {scheduleOrientation ? (
            <ScheduleOrientation type="PRE" />
          ) : (
            introBlock
          )}
        </div>
        <div className="bottom-bar">
          {/* <div className="btns">
            <div
              className="btn btn-l4l-dark"
              onClick={() => setFormModal("postRegistrationModal", false)}
            >
              Close
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PostRegistrationModal;
